// // import React, { useState, useEffect } from "react";
// // import { Link } from "react-router-dom";

// // const SelectPackage = () => {
// //   const [packages, setPackages] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [billingType, setBillingType] = useState("month"); // 'month' or 'year'
// //   const [error, setError] = useState(null);

// //   // Fetch all packages on component mount
// //   useEffect(() => {
// //     fetchPackages();
// //   }, []);

// //   // Function to fetch packages from the API
// //   const fetchPackages = async () => {
// //     try {
// //       setLoading(true);
// //       const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/packages");
// //       if (!response.ok) {
// //         throw new Error("Failed to fetch packages");
// //       }
// //       const data = await response.json();
// //       setPackages(data);
// //       setError(null);
// //     } catch (err) {
// //       console.error("Error fetching packages:", err);
// //       setError(err.message);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

//   // // Helper function to get package features
//   // const getPackageFeatures = (pkg) => {
//   //   const features = [];
//   //   if (pkg.pointOne) features.push(pkg.pointOne);
//   //   if (pkg.pointTwo) features.push(pkg.pointTwo);
//   //   if (pkg.pointThree) features.push(pkg.pointThree);
//   //   if (pkg.pointFour) features.push(pkg.pointFour);
//   //   if (pkg.pointFive) features.push(pkg.pointFive);
//   //   if (pkg.pointSix) features.push(pkg.pointSix);
//   //   if (pkg.pointSeven) features.push(pkg.pointSeven);
//   //   if (pkg.pointEight) features.push(pkg.pointEight);
//   //   if (pkg.pointNine) features.push(pkg.pointNine);
//   //   if (pkg.pointTen) features.push(pkg.pointTen);
//   //   return features;
//   // };

// //   return (
// //     // <>
// //     //   <div className="pricing-section ptb-100">
// //     //     <div className="container">
// //     //       <div className="row align-items-center">
// //     //         <div className="col-xl-12 col-lg-12">
// //     //           <div className="pricing-content text-center">
// //     //             <h2>Flexible Pricing Plans That Your Needs</h2>
// //     //             <p>
// //     //               Choose the plan that best fits your needs.
// //     //             </p>

// //     //             {loading ? (
// //     //               <div className="text-center py-5">
// //     //                 <div className="spinner-border text-primary" role="status">
// //     //                   <span className="visually-hidden">Loading...</span>
// //     //                 </div>
// //     //               </div>
// //     //             ) : error ? (
// //     //               <div className="alert alert-danger text-center" role="alert">
// //     //                 {error}
// //     //               </div>
// //     //             ) : (
// //     //               <div className="pricing-table">
// //     //                 <div className="row">
// //     //                   {packages.map((pkg, index) => (
// //     //                     <div
// //     //                       className="col-lg-4 col-sm-4"
// //     //                       key={pkg._id || index}
// //     //                     >
// //     //                       <div
// //     //                         className={`pricing-box ${
// //     //                           index === 1 ? "active" : ""
// //     //                         }`}
// //     //                         data-aos="fade-zoom-in"
// //     //                         data-aos-delay={index === 0 ? "100" : "200"}
// //     //                       >
// //     //                         {index === 1 && <span>Most Popular</span>}
// //     //                         <h3>{pkg.packageName}</h3>
// //     //                         <p>See Package Details</p>
// //     //                         <div className="price-number">
// //     //                           <h3>${pkg.price} USD</h3>
// //     //                         </div>
// //     //                         <div className="price-fetures">
// //     //                           <ul>
// //     //                             {getPackageFeatures(pkg).map((feature, idx) => (
// //     //                               <li key={idx}>{feature}</li>
// //     //                             ))}
// //     //                           </ul>
// //     //                         </div>
// //     //                         <Link
// //     //                           to={`/buy/${pkg._id}`}
// //     //                           className="default-btn"
// //     //                         >
// //     //                           <span>Get Started</span>
// //     //                           <i className="bx bx-chevron-right"></i>
// //     //                         </Link>
// //     //                       </div>
// //     //                     </div>
// //     //                   ))}
// //     //                   {packages.length === 0 && (
// //     //                     <div className="col-12 text-center py-5">
// //     //                       <p>
// //     //                         No packages available. Please add packages to
// //     //                         display.
// //     //                       </p>
// //     //                     </div>
// //     //                   )}
// //     //                 </div>
// //     //               </div>
// //     //             )}
// //     //           </div>
// //     //         </div>
// //     //       </div>
// //     //     </div>
// //     //   </div>
// //     // </>

// //     <><section className="pricing-style-two centred">
// //   <div className="auto-container">
// //     <div className="sec-title mb_60">
// //       <span className="sub-title">Pricing Plans</span>
// //       <h2>Our Affordable Pricing </h2>
// //     </div>
// //     <div className="row clearfix">
// //       <div className="col-lg-4 col-md-6 col-sm-12 pricing-block">
// //         <div className="pricing-block-two" >
// //           <div className="pricing-table">
// //             <div className="table-header mb_20">
// //               <h5>Personal Plan</h5>
// //               <p>For bloggers, freelancers &amp; businesses</p>
// //               <h2>$29<span>/Month</span></h2>
// //             </div>
// //             <div className="btn-box mb_40">
// //               <a href="index-2.html">Choose Plan</a>
// //             </div>
// //             <div className="table-content">
// //               <ul className="feature-list clearfix">
// //                 <li>Up to 10 Team Members</li>
// //                 <li>Unlimited Usage</li>
// //                 <li>Unlimited Drive Storage</li>
// //                 <li>Concierge Help Center</li>
// //                 <li>Smart Brand Personas</li>
// //                 <li>Custom AI Brand Models</li>
// //               </ul>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //       <div className="col-lg-4 col-md-6 col-sm-12 pricing-block">
// //         <div className="pricing-block-two active-block" >
// //           <div className="pricing-table">
// //             <div className="table-header mb_20">
// //               <h5>Business Plan</h5>
// //               <p>For bloggers, freelancers &amp; businesses</p>
// //               <h2>$39<span>/Month</span></h2>
// //             </div>
// //             <div className="btn-box mb_40">
// //               <a href="index-2.html">Choose Plan</a>
// //             </div>
// //             <div className="table-content">
// //               <ul className="feature-list clearfix">
// //                 <li>Up to 10 Team Members</li>
// //                 <li>Unlimited Usage</li>
// //                 <li>Unlimited Drive Storage</li>
// //                 <li>Concierge Help Center</li>
// //                 <li>Smart Brand Personas</li>
// //                 <li>Custom AI Brand Models</li>
// //               </ul>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //       <div className="col-lg-4 col-md-6 col-sm-12 pricing-block">
// //         <div className="pricing-block-two" >
// //           <div className="pricing-table">
// //             <div className="table-header mb_20">
// //               <h5>Advance Plan</h5>
// //               <p>For bloggers, freelancers &amp; businesses</p>
// //               <h2>$59<span>/Month</span></h2>
// //             </div>
// //             <div className="btn-box mb_40">
// //               <a href="index-2.html">Choose Plan</a>
// //             </div>
// //             <div className="table-content">
// //               <ul className="feature-list clearfix">
// //                 <li>Up to 10 Team Members</li>
// //                 <li>Unlimited Usage</li>
// //                 <li>Unlimited Drive Storage</li>
// //                 <li>Concierge Help Center</li>
// //                 <li>Smart Brand Personas</li>
// //                 <li>Custom AI Brand Models</li>
// //               </ul>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   </div>
// // </section>
// // </>
// //   );
// // };

// // export default SelectPackage;

// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// const SelectPackage = () => {
//   const [packages, setPackages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch all packages on component mount
//   useEffect(() => {
//     fetchPackages();
//   }, []);

//   const fetchPackages = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/packages");
//       if (!response.ok) {
//         throw new Error("Failed to fetch packages");
//       }
//       const data = await response.json();
//       setPackages(data);
//       setError(null);
//     } catch (err) {
//       console.error("Error fetching packages:", err);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Helper function to get all package features dynamically
//   const getPackageFeatures = (pkg) => {
//     return Object.keys(pkg)
//       .filter(
//         (key) =>
//           key.toLowerCase().startsWith("point") &&
//           pkg[key] &&
//           pkg[key].trim() !== ""
//       )
//       .map((key) => pkg[key]);
//   };

//   return (
//     // <section className="pricing-style-two centred" id="pricing-sec">
//     //   <div className="auto-container">
//     //     <div className="sec-title mb_60">
//     //       <span className="sub-title">Pricing Plans</span>
//     //       <h2>Our Affordable Pricing</h2>
//     //     </div>

//     //     {loading ? (
//     //       <div className="text-center py-5">
//     //         <div className="spinner-border text-primary" role="status">
//     //           <span className="visually-hidden">Loading...</span>
//     //         </div>
//     //       </div>
//     //     ) : error ? (
//     //       <div className="alert alert-danger text-center" role="alert">
//     //         {error}
//     //       </div>
//     //     ) : packages.length === 0 ? (
//     //       <div className="text-center py-5">
//     //         <p>No packages available. Please add packages to display.</p>
//     //       </div>
//     //     ) : (
//     //       <div className="row clearfix">
//     //         {packages.map((pkg, index) => (
//     //           <div
//     //             className="col-lg-4 col-md-6 col-sm-12 pricing-block"
//     //             key={pkg._id || index}
//     //           >
//     //             <div
//     //               className={`pricing-block-two ${
//     //                 index === 1 ? "active-block" : ""
//     //               }`}
//     //             >
//     //               <div className="pricing-table">
//     //                 {/* Header */}
//     //                 <div className="table-header mb_20">
//     //                   <h5>{pkg.packageName}</h5>
//     //                   <h2>
//     //                     ${pkg.price}
//     //                     <span></span>
//     //                   </h2>
//     //                 </div>

//     //                 {/* Button */}
//     //                 <div className="btn-box mb_40">
//     //                   <Link to={`/buy/${pkg._id}`}>Choose Plan</Link>
//     //                 </div>

//     //                 {/* Features */}
//     //                 <div className="table-content">
//     //                   <ul className="feature-list clearfix">
//     //                     {getPackageFeatures(pkg).map((feature, idx) => (
//     //                       <li key={idx}>{feature}</li>
//     //                     ))}
//     //                   </ul>
//     //                 </div>
//     //               </div>
//     //             </div>
//     //           </div>
//     //         ))}
//     //       </div>
//     //     )}
//     //   </div>
//     // </section>

//     <><section className="price-area price-tab pt-140 pb-140">
//   <div className="container">
//     <div className="row justify-content-center">
//       <div className="col-xxl-6 col-xl-7 col-lg-9 col-md-10">
//         <div className="section-area text-center mb-45">
//           <span className="section-subtitle tp_fade_left">Pricing Plan</span>
//           <h2 className="section-title tp_title_slideup mb-0 section-title tp_title_slideup-big">Personalized Pricing Plans
//             Suited to You.</h2>
//         </div>
//       </div>
//     </div>
//     <div className="row">
//       <div className="col-12">
                                        
//       </div>
//     </div>
//     <div id="monthly" className="wrapper-full">
//       <div className="row align-items-end">
//         <div className="col-xl-3 col-lg-6 col-md-6 tp_fade_left" data-fade-from="left">
//           <div className="price-item price-item-1">
//             <div className="price-item-head">
//               <h5 className="price-item-title">Free Trial</h5>
//               <h2 className="price-item-amount-title">Free</h2>
//               <p>No Need For Credit Card</p>
//               <a className="price-item-btn" href="#">Choose Plan<i className="fa-light fa-angle-right" /></a>
//             </div>
//             <ul className="price-item-list">
//               <li>Priority email &amp; chat support 0</li>
//               <li>Access 12+ use-cases</li>
//               <li className="not-abatable">Generate 1,000 AI Words / month</li>
//               <li className="not-abatable">Google Docs style editor</li>
//               <li className="not-abatable">Compose &amp; command features</li>
//             </ul>
//           </div>
//         </div>
//         <div className="col-xl-3 col-lg-6 col-md-6 tp_fade_left" data-fade-from="left" data-delay=".8">
//           <div className="price-item active">
//             <div className="price-item-option">
//               <span>Best Choice</span>
//             </div>
//             <div className="price-item-head">
//               <h5 className="price-item-title">Standard Plan</h5>
//               <div className="price-item-amount"><del>$85</del><h2 className="price-item-amount-title">$35<span>.8</span></h2><span className="amount-offer">49.2%</span></div>
//               <p>/Month (annually billed)</p>
//               <span className="price-item-offer">SAVE UP TO $54.2</span>
//               <a className="price-item-btn" href="#">Choose Plan<i className="fa-light fa-angle-right" /></a>
//             </div>
//             <ul className="price-item-list">
//               <li>Priority email &amp; chat support 0</li>
//               <li>Access 12+ use-cases</li>
//               <li>Generate 1,000 AI Words / month</li>
//               <li className="not-abatable">Google Docs style editor</li>
//               <li className="not-abatable">Compose &amp; command features</li>
//             </ul>
//           </div>
//         </div>
//         <div className="col-xl-3 col-lg-6 col-md-6 tp_fade_left" data-fade-from="left" data-delay="1.1">
//           <div className="price-item">
//             <div className="price-item-head">
//               <h5 className="price-item-title">Liter Plan</h5>
//               <div className="price-item-amount"><del>$89</del><h2 className="price-item-amount-title">$56<span>.8</span></h2><span className="amount-offer">30%</span></div>
//               <p>/Month (annually billed)</p>
//               <span className="price-item-offer">SAVE UP TO $54.2</span>
//               <a className="price-item-btn" href="#">Choose Plan<i className="fa-light fa-angle-right" /></a>
//             </div>
//             <ul className="price-item-list">
//               <li>Priority email &amp; chat support 0</li>
//               <li>Access 12+ use-cases</li>
//               <li>Generate 1,000 AI Words / month</li>
//               <li>Google Docs style editor</li>
//               <li className="not-abatable">Compose &amp; command features</li>
//             </ul>
//           </div>
//         </div>
//         <div className="col-xl-3 col-lg-6 col-md-6 tp_fade_left" data-fade-from="left" data-delay="1.4">
//           <div className="price-item">
//             <div className="price-item-head">
//               <h5 className="price-item-title">Premium Plan</h5>
//               <div className="price-item-amount"><del>$99</del><h2 className="price-item-amount-title">$89<span>.8</span></h2><span className="amount-offer">30%</span></div>
//               <p>/Month (annually billed)</p>
//               <span className="price-item-offer">SAVE UP TO $27.2</span>
//               <a className="price-item-btn" href="#">Choose Plan<i className="fa-light fa-angle-right" /></a>
//             </div>
//             <ul className="price-item-list">
//               <li>Priority email &amp; chat support 0</li>
//               <li>Access 12+ use-cases</li>
//               <li>Generate 1,000 AI Words / month</li>
//               <li>Google Docs style editor</li>
//               <li>Compose &amp; command features</li>
//             </ul>
//           </div>
//         </div>
//       </div>
//     </div>
//     <div id="hourly" className="wrapper-full hide">
//       <div className="row align-items-end">
//         <div className="col-xl-3 col-lg-6 col-md-6 tp_fade_left" data-fade-from="left">
//           <div className="price-item price-item-1">
//             <div className="price-item-head">
//               <h5 className="price-item-title">Free Trial</h5>
//               <h2 className="price-item-amount-title">Free</h2>
//               <p>No Need For Credit Card</p>
//               <a className="price-item-btn" href="#">Choose Plan<i className="fa-light fa-angle-right" /></a>
//             </div>
//             <ul className="price-item-list">
//               <li>Priority email &amp; chat support 0</li>
//               <li>Access 12+ use-cases</li>
//               <li className="not-abatable">Generate 1,000 AI Words / month</li>
//               <li className="not-abatable">Google Docs style editor</li>
//               <li className="not-abatable">Compose &amp; command features</li>
//             </ul>
//           </div>
//         </div>
//         <div className="col-xl-3 col-lg-6 col-md-6 tp_fade_left" data-fade-from="left" data-delay=".8">
//           <div className="price-item active">
//             <div className="price-item-option">
//               <span>Best Choice</span>
//             </div>
//             <div className="price-item-head">
//               <h5 className="price-item-title">Standard Plan</h5>
//               <div className="price-item-amount"><del>$95</del><h2 className="price-item-amount-title">$55<span>.8</span></h2><span className="amount-offer">49.2%</span></div>
//               <p>/Month (annually billed)</p>
//               <span className="price-item-offer">SAVE UP TO $54.2</span>
//               <a className="price-item-btn" href="#">Choose Plan<i className="fa-light fa-angle-right" /></a>
//             </div>
//             <ul className="price-item-list">
//               <li>Priority email &amp; chat support 0</li>
//               <li>Access 12+ use-cases</li>
//               <li>Generate 1,000 AI Words / month</li>
//               <li className="not-abatable">Google Docs style editor</li>
//               <li className="not-abatable">Compose &amp; command features</li>
//             </ul>
//           </div>
//         </div>
//         <div className="col-xl-3 col-lg-6 col-md-6 tp_fade_left" data-fade-from="left" data-delay="1.1">
//           <div className="price-item">
//             <div className="price-item-head">
//               <h5 className="price-item-title">Liter Plan</h5>
//               <div className="price-item-amount"><del>$99</del><h2 className="price-item-amount-title">$76<span>.8</span></h2><span className="amount-offer">30%</span></div>
//               <p>/Month (annually billed)</p>
//               <span className="price-item-offer">SAVE UP TO $54.2</span>
//               <a className="price-item-btn" href="#">Choose Plan<i className="fa-light fa-angle-right" /></a>
//             </div>
//             <ul className="price-item-list">
//               <li>Priority email &amp; chat support 0</li>
//               <li>Access 12+ use-cases</li>
//               <li>Generate 1,000 AI Words / month</li>
//               <li>Google Docs style editor</li>
//               <li className="not-abatable">Compose &amp; command features</li>
//             </ul>
//           </div>
//         </div>
//         <div className="col-xl-3 col-lg-6 col-md-6 tp_fade_left" data-fade-from="left" data-delay="1.4">
//           <div className="price-item">
//             <div className="price-item-head">
//               <h5 className="price-item-title">Premium Plan</h5>
//               <div className="price-item-amount"><del>$240</del><h2 className="price-item-amount-title">$99<span>.8</span></h2><span className="amount-offer">30%</span></div>
//               <p>/Month (annually billed)</p>
//               <span className="price-item-offer">SAVE UP TO $27.2</span>
//               <a className="price-item-btn" href="#">Choose Plan<i className="fa-light fa-angle-right" /></a>
//             </div>
//             <ul className="price-item-list">
//               <li>Priority email &amp; chat support 0</li>
//               <li>Access 12+ use-cases</li>
//               <li>Generate 1,000 AI Words / month</li>
//               <li>Google Docs style editor</li>
//               <li>Compose &amp; command features</li>
//             </ul>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// </section>
// </>
//   );
// };

// export default SelectPackage;

// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// const SelectPackage = () => {
//   const [packages, setPackages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch all packages
//   useEffect(() => {
//     fetchPackages();
//   }, []);

//   const fetchPackages = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/packages");
//       if (!response.ok) {
//         throw new Error("Failed to fetch packages");
//       }
//       const data = await response.json();
//       setPackages(data);
//       setError(null);
//     } catch (err) {
//       console.error("Error fetching packages:", err);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Collect features dynamically
//   const getPackageFeatures = (pkg) =>
//     Object.keys(pkg)
//       .filter(
//         (key) =>
//           key.toLowerCase().startsWith("point") &&
//           pkg[key] &&
//           pkg[key].trim() !== ""
//       )
//       .map((key) => pkg[key]);

//   return (
//     // <section className="price-area price-tab pt-140 pb-140" id="pricing-sec">
//     //   <div className="container">
//     //     <div className="row justify-content-center">
//     //       <div className="col-xxl-6 col-xl-7 col-lg-9 col-md-10">
//     //         <div className="section-area text-center mb-45">
//     //           <span className="section-subtitle tp_fade_left">Pricing Plan</span>
//     //           <h2 className="section-title tp_title_slideup mb-0 tp_title_slideup-big">
//     //             Personalized Pricing Plans Suited to You.
//     //           </h2>
//     //         </div>
//     //       </div>
//     //     </div>

//     //     {loading ? (
//     //       <div className="text-center py-5">
//     //         <div className="spinner-border text-primary" role="status">
//     //           <span className="visually-hidden">Loading...</span>
//     //         </div>
//     //       </div>
//     //     ) : error ? (
//     //       <div className="alert alert-danger text-center" role="alert">
//     //         {error}
//     //       </div>
//     //     ) : packages.length === 0 ? (
//     //       <div className="text-center py-5">
//     //         <p>No packages available. Please add packages to display.</p>
//     //       </div>
//     //     ) : (
//     //       <div className="row align-items-end">
//     //         {packages.slice(0, 3).map((pkg, index) => (
//     //           <div
//     //             className="col-xl-4 col-lg-6 col-md-6 tp_fade_left"
//     //             data-fade-from="left"
//     //             data-delay={index * 0.3}
//     //             key={pkg._id || index}
//     //           >
//     //             <div
//     //               className={`price-item ${index === 1 ? "active" : ""}`}
//     //             >
//     //               {index === 1 && (
//     //                 <div className="price-item-option">
//     //                   <span>Best Choice</span>
//     //                 </div>
//     //               )}

//     //               {/* Header */}
//     //               <div className="price-item-head">
//     //                 <h5 className="price-item-title">{pkg.packageName}</h5>
//     //                 <div className="price-item-amount">
//     //                   <h2 className="price-item-amount-title">
//     //                     ${pkg.price}
//     //                   </h2>
//     //                 </div>
//     //                 <p>{pkg.description || "Perfect for you"}</p>
//     //                 <Link
//     //                   to={`/buy/${pkg._id}`}
//     //                   className="price-item-btn"
//     //                 >
//     //                   Choose Plan <i className="fa-light fa-angle-right" />
//     //                 </Link>
//     //               </div>

//     //               {/* Features */}
//     //               <ul className="price-item-list">
//     //                 {getPackageFeatures(pkg).map((feature, idx) => (
//     //                   <li key={idx}>{feature}</li>
//     //                 ))}
//     //               </ul>
//     //             </div>
//     //           </div>
//     //         ))}
//     //       </div>
//     //     )}
//     //   </div>
//     // </section>

//     <> <section className="gt-pricing-section-3 fix section-padding bg-cover" style={{backgroundImage: 'url("assets/img/home-3/pricing-bg.jpg")'}}>
//   <div className="container">
//     <div className="gt-section-title text-center style-3">
//       <h6 className="wow fadeInUp tt-capitalize">our pricing plan</h6>
//       <h2 className="char-animation">
//         Boostly pricing plan
//       </h2>
//     </div>
   
//     <div className="pricing__tab-content">
      
//       <div className="tab-content" id="nav-tabContent">
//         <div className="tab-pane fade active show" id="pt-1" role="tabpanel" aria-labelledby="pt-1-tab">
//           <div className="row">
//             <div className="col-xl-4 col-lg-6 col-md-6 left_view">
//               <div className="gt-pricing-box-items pricing-style-3">
//                 <div className="gradient-bg" />
//                 <div className="gt-pricing-header">
//                   <h2>
//                     <sup>$</sup>
//                     32
//                     <sub></sub>
//                   </h2>
//                   <span className="sub-texts">pro</span>
//                 </div>
//                 <a href="pricing.html" className="gt-theme-btn">
//                   Get this plan
//                 </a>
//                 <ul className="gt-pricing-list">
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     3 autopilot projects
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     Automatic keyword research
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     Internal &amp; external linking
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     AI SEO Recommendations
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     Content scheduling
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     Automatic publishing
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     AI &amp; Stock images
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     15% off backlinks
//                   </li>
//                 </ul>
//               </div>
//             </div>
//             <div className="col-xl-4 col-lg-6 col-md-6 top_view">
//               <div className="gt-pricing-box-items pricing-style-3">
//                 <div className="gradient-bg" />
//                 <div className="gt-pricing-header">
//                   <h2>
//                     <sup>$</sup>
//                     69
//                     <sub></sub>
//                   </h2>
//                   <span className="sub-texts">Advance</span>
//                 </div>
//                 <a href="pricing.html" className="gt-theme-btn">
//                   Get this plan
//                 </a>
//                 <ul className="gt-pricing-list">
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     3 autopilot projects
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     Automatic keyword research
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     Internal &amp; external linking
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     AI SEO Recommendations
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     Content scheduling
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     Automatic publishing
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     AI &amp; Stock images
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     15% off backlinks
//                   </li>
//                 </ul>
//               </div>
//             </div>
//             <div className="col-xl-4 col-lg-6 col-md-6 right_view">
//               <div className="gt-pricing-box-items pricing-style-3">
//                 <div className="gradient-bg" />
//                 <div className="gt-pricing-header">
//                   <h2>
//                     <sup>$</sup>
//                     99
//                     <sub></sub>
//                   </h2>
//                   <span className="sub-texts">diamond</span>
//                 </div>
//                 <a href="pricing.html" className="gt-theme-btn">
//                   Get this plan
//                 </a>
//                 <ul className="gt-pricing-list">
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     3 autopilot projects
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     Automatic keyword research
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     Internal &amp; external linking
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     AI SEO Recommendations
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     Content scheduling
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     Automatic publishing
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     AI &amp; Stock images
//                   </li>
//                   <li>
//                     <i className="fa-solid fa-circle-check" />
//                     15% off backlinks
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
        
//       </div>
//     </div>
//   </div>
// </section>
// </>
//   );
// };

// export default SelectPackage;


// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// const SelectPackage = () => {
//   const [packages, setPackages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch all packages
//   useEffect(() => {
//     fetchPackages();
//   }, []);

//   const fetchPackages = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/packages");
//       if (!response.ok) {
//         throw new Error("Failed to fetch packages");
//       }
//       const data = await response.json();
//       setPackages(data);
//       setError(null);
//     } catch (err) {
//       console.error("Error fetching packages:", err);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Extract dynamic features
//   const getPackageFeatures = (pkg) =>
//     Object.keys(pkg)
//       .filter(
//         (key) =>
//           key.toLowerCase().startsWith("point") &&
//           pkg[key] &&
//           pkg[key].trim() !== ""
//       )
//       .map((key) => pkg[key]);

//   return (
//     // <section
//     //   className="gt-pricing-section-3 fix section-padding bg-cover"
//     //   style={{ backgroundImage: 'url("assets/img/home-3/pricing-bg.jpg")' }}
//     // >
//     //   <div className="container">
//     //     <div className="gt-section-title text-center style-3">
//     //       <h6 className="wow fadeInUp tt-capitalize">our pricing plan</h6>
//     //       <h2 className="char-animation">Boostly pricing plan</h2>
//     //     </div>

//     //     {loading ? (
//     //       <div className="text-center py-5">
//     //         <div className="spinner-border text-primary" role="status">
//     //           <span className="visually-hidden">Loading...</span>
//     //         </div>
//     //       </div>
//     //     ) : error ? (
//     //       <div className="alert alert-danger text-center" role="alert">
//     //         {error}
//     //       </div>
//     //     ) : packages.length === 0 ? (
//     //       <div className="text-center py-5">
//     //         <p>No packages available. Please add packages to display.</p>
//     //       </div>
//     //     ) : (
//     //       <div className="pricing__tab-content">
//     //         <div className="tab-content" id="nav-tabContent">
//     //           <div
//     //             className="tab-pane fade active show"
//     //             id="pt-1"
//     //             role="tabpanel"
//     //             aria-labelledby="pt-1-tab"
//     //           >
//     //             <div className="row">
//     //               {packages.slice(0, 3).map((pkg, index) => (
//     //                 <div
//     //                   key={pkg._id || index}
//     //                   className={`col-xl-4 col-lg-6 col-md-6 ${
//     //                     index === 0
//     //                       ? "left_view"
//     //                       : index === 1
//     //                       ? "top_view"
//     //                       : "right_view"
//     //                   }`}
//     //                 >
//     //                   <div className="gt-pricing-box-items pricing-style-3">
//     //                     <div className="gradient-bg" />
//     //                     <div className="gt-pricing-header">
//     //                       <h2>
//     //                         <sup>$</sup>
//     //                         {pkg.price}
//     //                         <sub></sub>
//     //                       </h2>
//     //                       <span className="sub-texts">
//     //                         {pkg.packageName || "Plan"}
//     //                       </span>
//     //                     </div>
//     //                     <Link
//     //                       to={`/buy/${pkg._id}`}
//     //                       className="gt-theme-btn"
//     //                     >
//     //                       Buy Now
//     //                     </Link>
//     //                     <ul className="gt-pricing-list">
//     //                       {getPackageFeatures(pkg).map((feature, i) => (
//     //                         <li key={i}>
//     //                           <i className="fa-solid fa-circle-check" />{" "}
//     //                           {feature}
//     //                         </li>
//     //                       ))}
//     //                     </ul>
//     //                   </div>
//     //                 </div>
//     //               ))}
//     //             </div>
//     //           </div>
//     //         </div>
//     //       </div>
//     //     )}
//     //   </div>
//     // </section>

//     <> <section className="pricing-area-four pt-65 pb-165 rel z-1">
//   <div className="container">
//     <div className="row justify-content-center">
//       <div className="col-xl-5 col-lg-7">
//         <div className="pricing-plan-content text-center mb-65 wow fadeInUp delay-0-2s">
//           <div className="section-title text-center mb-30">
//             <span className="sub-title style-two mb-20">Pricing Plan</span>
//             <h2>Choose Your Perfect Pricing Package</h2>
//           </div>
          
//         </div>
//       </div>
//     </div>
//     <div className="tab-content wow fadeInUp delay-0-4s">
//       <div className="tab-pane fade show active" id="monthlyTwo">
//         <div className="row justify-content-center">
//           <div className="col-xl-4 col-md-6">
//             <div className="pricing-plan-three style-two">
//               <span className="badge">popular</span>
//               <h4>Basic Plan</h4>
//               <ul className="list-style-two">
//                 <li>Landing page design (10 pages)</li>
//                 <li>HTML+CSS design (12 pages)</li>
//                 <li>Social Media Marketing</li>
//                 <li>Domin hosting provider</li>
//                 <li>Online support (24/7)</li>
//                 <li>WordPres development</li>
//               </ul>
//               <div className="price-and-btn">
//                 <div className="content">
//                   <span className="price">248</span>
//                   <span className="save"><span> </span></span>
//                   <a href="pricing.html" className="theme-btn style-three">Choose Package <i className="fas fa-angle-double-right" /></a>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="col-xl-4 col-md-6">
//             <div className="pricing-plan-three style-two">
//               <span className="badge">popular</span>
//               <h4>Ultra Plan</h4>
//               <ul className="list-style-two">
//                 <li>Landing page design (10 pages)</li>
//                 <li>HTML+CSS design (12 pages)</li>
//                 <li>Social Media Marketing</li>
//                 <li>Domin hosting provider</li>
//                 <li>Online support (24/7)</li>
//                 <li>WordPres development</li>
//               </ul>
//               <div className="price-and-btn">
//                 <div className="content">
//                   <span className="price">548</span>
//                   <span className="save"><span></span></span>
//                   <a href="pricing.html" className="theme-btn style-three">Choose Package <i className="fas fa-angle-double-right" /></a>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="col-xl-4 col-md-6">
//             <div className="pricing-plan-three style-two">
//               <span className="badge">popular</span>
//               <h4>Gold Plan</h4>
//               <ul className="list-style-two">
//                 <li>Landing page design (10 pages)</li>
//                 <li>HTML+CSS design (12 pages)</li>
//                 <li>Social Media Marketing</li>
//                 <li>Domin hosting provider</li>
//                 <li>Online support (24/7)</li>
//                 <li>WordPres development</li>
//               </ul>
//               <div className="price-and-btn">
//                 <div className="content">
//                   <span className="price">948</span>
//                   <span className="save"><span></span></span>
//                   <a href="pricing.html" className="theme-btn style-three">Choose Package <i className="fas fa-angle-double-right" /></a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
      
//     </div>
//   </div>
//   <div className="wave-shapes">
//     <img className="shape one" src="assets/images/shapes/pricing-bg-wave2.png" alt="Wave Shape" />
//   </div>
// </section>
// </>
//   );
// };

// export default SelectPackage;


// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// const SelectPackage = () => {
//   const [packages, setPackages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch all packages from backend
//   useEffect(() => {
//     fetchPackages();
//   }, []);

//   const fetchPackages = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/packages");
//       if (!response.ok) {
//         throw new Error("Failed to fetch packages");
//       }
//       const data = await response.json();
//       setPackages(data);
//       setError(null);
//     } catch (err) {
//       console.error("Error fetching packages:", err);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Extract dynamic feature points
//   const getPackageFeatures = (pkg) =>
//     Object.keys(pkg)
//       .filter(
//         (key) =>
//           key.toLowerCase().startsWith("point") &&
//           pkg[key] &&
//           pkg[key].trim() !== ""
//       )
//       .map((key) => pkg[key]);

//   return (
//     // <section className="pricing-area-four pt-65 pb-165 rel z-1" id="pricing-sec">
//     //   <div className="container">
//     //     <div className="row justify-content-center">
//     //    <div class="col-xl-8 col-lg-10">
//     //                     <div class="section-title text-center mb-55 wow fadeInUp delay-0-2s">
//     //                         <span class="sub-title mb-20">Pricing Plan</span>
//     //                         <h2>Best Pricing Package</h2>
//     //                     </div>
//     //                 </div>
//     //     </div>

//     //     {loading ? (
//     //       <div className="text-center py-5">
//     //         <div className="spinner-border text-primary" role="status">
//     //           <span className="visually-hidden">Loading...</span>
//     //         </div>
//     //       </div>
//     //     ) : error ? (
//     //       <div className="alert alert-danger text-center" role="alert">
//     //         {error}
//     //       </div>
//     //     ) : packages.length === 0 ? (
//     //       <div className="text-center py-5">
//     //         <p>No packages available. Please add packages to display.</p>
//     //       </div>
//     //     ) : (
//     //       <div className="tab-content wow fadeInUp delay-0-4s">
//     //         <div className="tab-pane fade show active" id="monthlyTwo">
//     //           <div className="row justify-content-center">
//     //             {packages.slice(0, 3).map((pkg, index) => (
//     //               <div key={pkg._id || index} className="col-xl-4 col-md-6">
//     //                 <div className="pricing-plan-three style-two">
//     //                   <span className="badge">popular</span>
//     //                   <h4>{pkg.packageName || `Plan ${index + 1}`}</h4>
//     //                   <ul className="list-style-two">
//     //                     {getPackageFeatures(pkg).map((feature, i) => (
//     //                       <li key={i}>{feature}</li>
//     //                     ))}
//     //                   </ul>
//     //                   <div className="price-and-btn">
//     //                     <div className="content">
//     //                       <span className="price">{pkg.price}</span>
//     //                       <span className="save">
//     //                         <span></span>
//     //                       </span>
//     //                       <Link
//     //                         to={`/buy/${pkg._id}`}
//     //                         className="theme-btn style-three"
//     //                       >
//     //                         Choose Package{" "}
//     //                         <i className="fas fa-angle-double-right" />
//     //                       </Link>
//     //                     </div>
//     //                   </div>
//     //                 </div>
//     //               </div>
//     //             ))}
//     //           </div>
//     //         </div>
//     //       </div>
//     //     )}
//     //   </div>

//     //   <div className="wave-shapes">
//     //     <img
//     //       className="shape one"
//     //       src="assets/images/shapes/pricing-bg-wave2.png"
//     //       alt="Wave Shape"
//     //     />
//     //   </div>
//     // </section>

//     <> <section className="position-relative">
//   <div className="cs_bg_shape_1 cs_accent_bg cs_radius_15 position-absolute" />
//   <div className="cs_height_125 cs_height_lg_70" />
//   <div className="container position-relative z-1">
//     <div className="cs_section_heading cs_style_1 cs_mb_42 text-center">
//       <h2 className="cs_section_title cs_fs_50 mb-0 wow fadeInDown">Transparent pricing plans, find the <br /> perfect fit for your needs</h2>
//     </div>
//     <ul className="cs_pricing_control cs_type_1 cs_center p-0 position-relative">
    
      
//     </ul>
//     <div className="cs_pricing_table_wrapper_2">
//       <div className="cs_pricing_table cs_style_1 cs_type_3 cs_white_bg cs_radius_20 position-relative wow fadeInLeft">
//         <div className="cs_pricing_head cs_mb_14">
//           <h2 className="cs_fs_38 mb-0">Free</h2>
//           <p className="cs_mb_18">Free for small team</p>
//           <hr />
//         </div>
//         <h3 className="cs_fs_38 cs_mb_17">$<span className="monthlyPrice">0</span><span className="yearlyPrice">0</span>
//           <small className="cs_fs_18 cs_normal cs_gray2_color">/
//             <span className="monthlyText">month</span>
//             <span className="yearlyText">year</span>
//           </small>
//         </h3>
//         <div className="cs_mb_36">
//           <ul className="cs_pricing_feature_list cs_mp_0">
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Unlimited cards
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Up to 10 boards per
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Unlimited Power-Ups per board
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-xmark" /></span>
//               Unlimited storage (10MB/file)
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-xmark" /></span>
//               Unlimited activity log
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-xmark" /></span>
//               Assignee and due dates
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-xmark" /></span>
//               Assignee and due dates
//             </li>
//           </ul>
//         </div>
//         <a href="contact.html" aria-label="Buy service button" className="cs_pricing_btn cs_center cs_fs_16 cs_semibold">Choose Plan</a>
//       </div>
//       <div className="cs_pricing_table cs_style_1 cs_type_3 cs_white_bg cs_radius_20 active position-relative overflow-hidden wow fadeInDown">
//         <span className="cs_pricing_badge cs_fs_16 position-absolute">Most Popular</span>
//         <div className="cs_pricing_head cs_mb_14">
//           <h2 className="cs_fs_38 mb-0">Standard</h2>
//           <p className="cs_mb_18">Most popular deal</p>
//           <hr />
//         </div>
//         <h3 className="cs_fs_38 cs_mb_17">$<span className="monthlyPrice">10</span><span className="yearlyPrice">80</span>
//           <small className="cs_fs_18 cs_normal cs_gray2_color">/
//             <span className="monthlyText">month</span>
//             <span className="yearlyText">year</span>
//           </small>
//         </h3>
//         <div className="cs_mb_36">
//           <ul className="cs_pricing_feature_list cs_mp_0">
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Unlimited cards
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Up to 10 boards per
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Unlimited Power-Ups per board
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Unlimited storage (10MB/file)
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Unlimited activity log
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-xmark" /></span>
//               Assignee and due dates
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-xmark" /></span>
//               Assignee and due dates
//             </li>
//           </ul>
//         </div>
//         <a href="contact.html" aria-label="Buy service button" className="cs_pricing_btn cs_center cs_fs_16 cs_semibold">Choose Plan</a>
//       </div>
//       <div className="cs_pricing_table cs_style_1 cs_type_3 cs_white_bg cs_radius_20 position-relative wow fadeInRight">
//         <div className="cs_pricing_head cs_mb_14">
//           <h2 className="cs_fs_38 mb-0">Premium</h2>
//           <p className="cs_mb_18">For your large team</p>
//           <hr />
//         </div>
//         <h3 className="cs_fs_38 cs_mb_17">$<span className="monthlyPrice">20</span><span className="yearlyPrice">90</span>
//           <small className="cs_fs_18 cs_normal cs_gray2_color">/
//             <span className="monthlyText">month</span>
//             <span className="yearlyText">year</span>
//           </small>
//         </h3>
//         <div className="cs_mb_36">
//           <ul className="cs_pricing_feature_list cs_mp_0">
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Unlimited cards
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Up to 10 boards per
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Unlimited Power-Ups per board
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Unlimited storage (10MB/file)
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Unlimited activity log
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Assignee and due dates
//             </li>
//             <li>
//               <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color"><i className="fa-solid fa-check" /></span>
//               Assignee and due dates
//             </li>
//           </ul>
//         </div>
//         <a href="contact.html" aria-label="Buy service button" className="cs_pricing_btn cs_center cs_fs_16 cs_semibold">Choose Plan</a>
//       </div>
//     </div>
//   </div>
//   <div className="cs_height_140 cs_height_lg_80" />
// </section>
// </>
//   );
// };

// export default SelectPackage;


import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const SelectPackage = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      setLoading(true);
      const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/packages");
      if (!response.ok) throw new Error("Failed to fetch packages");
      const data = await response.json();
      setPackages(data);
    } catch (err) {
      console.error("Error fetching packages:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Extract dynamic feature points
  const getPackageFeatures = (pkg) =>
    Object.keys(pkg)
      .filter(
        (key) =>
          key.toLowerCase().startsWith("point") &&
          pkg[key] &&
          pkg[key].trim() !== ""
      )
      .map((key) => pkg[key]);

  return (
    <section className="position-relative" id="pricing-sec">
      <div className="cs_bg_shape_1 cs_accent_bg cs_radius_15 position-absolute" />
      <div className="cs_height_125 cs_height_lg_70" />
      <div className="container position-relative z-1">
        <div className="cs_section_heading cs_style_1 cs_mb_42 text-center">
          <h2 className="cs_section_title cs_fs_50 mb-0 wow fadeInDown">
            Transparent pricing plans, find the <br /> perfect fit for your
            needs
          </h2>
        </div>

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : error ? (
          <div className="alert alert-danger text-center" role="alert">
            {error}
          </div>
        ) : packages.length === 0 ? (
          <div className="text-center py-5">
            <p>No packages available.</p>
          </div>
        ) : (
          <div className="cs_pricing_table_wrapper_2">
            {packages.slice(0, 3).map((pkg, index) => (
              <div
                key={pkg._id || index}
                className={`cs_pricing_table cs_style_1 cs_type_3 cs_white_bg cs_radius_20 position-relative wow ${
                  index === 0
                    ? "fadeInLeft"
                    : index === 1
                    ? "fadeInDown active overflow-hidden"
                    : "fadeInRight"
                }`}
              >
                {index === 1 && (
                  <span className="cs_pricing_badge cs_fs_16 position-absolute">
                    Most Popular
                  </span>
                )}

                <div className="cs_pricing_head cs_mb_14">
                  <h2 className="cs_fs_38 mb-0">
                    {pkg.packageName || "Unnamed Plan"}
                  </h2>
                  
                  <hr />
                </div>

                <h3 className="cs_fs_38 cs_mb_17">
                  ${pkg.price || 0}
                  <small className="cs_fs_18 cs_normal cs_gray2_color">
                   
                  </small>
                </h3>

                <div className="cs_mb_36">
                  <ul className="cs_pricing_feature_list cs_mp_0">
                    {getPackageFeatures(pkg).map((feature, i) => (
                      <li key={i}>
                        <span className="cs_feature_icon cs_center cs_radius_100 cs_accent_bg cs_white_color">
                          <i className="fa-solid fa-check" />
                        </span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                <Link
                  to={`/buy/${pkg._id}`}
                  aria-label="Buy service button"
                  className="cs_pricing_btn cs_center cs_fs_16 cs_semibold"
                >
                  Choose Plan
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="cs_height_140 cs_height_lg_80" />
    </section>
  );
};

export default SelectPackage;




